import React from 'react';

const Icon = ({ value, onClick }) => {
  return (
    <img src={value} alt="Icon" onClick={onClick} style={{ cursor: 'pointer' }} />
  );
};

export default Icon;
